var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code-form"},[_c('QrCode',{staticClass:"qr-code-form__qr-code",attrs:{"background":"transparent","margin":1,"render-as":'svg',"size":280,"value":_vm.component.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }